import { useTranslation } from "react-i18next";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

const WorkflowsTypeCard = (props) => {
  const { title, description, type, exists, access } = props;
  const src = exists
    ? "/img/new-icons/checked-square.svg"
    : "/img/new-icons/add.svg";

  const createWorkflow = () => {
    submit(`/actions/custom-workflows/${type}/create`, {
      method: "POST",
      body: { access },
    });
  };
  return (
    <article className="workflow-type-card">
      <div>
        <p className="s2">{title}</p>
        <p className="p5">{description}</p>
      </div>

      <SvgIcon
        classNames={`create-button${exists ? " exists" : ""}`}
        src={src}
        onClickFn={(e) => {
          e.stopPropagation();
          if (!exists) createWorkflow();
        }}
        noFilterOnLight={!!exists}
      />
    </article>
  );
};
const LearnWorkflowsList = ({
  customWorkflowsList,
  workflows,
  access,
  children,
}) => {
  const { t } = useTranslation("coaching-portal");
  return (
    <aside className="mobile-hidden">
      <h4>{t("customWorkflows.explore")}</h4>
      {customWorkflowsList?.length === 0 && !children && (
        <p className="s2 ml-2">{t("customWorkflows.comingSoon")}</p>
      )}
      {customWorkflowsList.map((w) => {
        const exists = workflows.find((workflow) => workflow.type === w.type);
        return (
          <WorkflowsTypeCard
            key={w.type}
            type={w.type}
            title={t(`customWorkflows.workflowName.${w.type}`)}
            description={t("customWorkflows.learnWorkflowDescription")}
            exists={exists}
            access={access}
          />
        );
      })}
      {children}
    </aside>
  );
};
export default LearnWorkflowsList;
